import { fetchPersea } from "@/config/axios/config-axios";

interface BenefitsParams {
  limit?: number;
  page?: number;
  cache?: boolean;
  user_main_key?: string;
  contract_address?: string;
  [key: string]: unknown;
}

export const getBenefit = async (params: BenefitsParams) => {
  return await fetchPersea(`/benefits?${Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&')}`, 'GET');
};

export const getBenefits = async (params: BenefitsParams = {}) => {
  const response = await fetchPersea('/benefits', 'GET', { ...params, limit: 100 });
  
  if (!Array.isArray(response)) {
    return response;
  }

  const uniqueBenefitsMap = new Map();
  
  response.forEach(benefit => {
    if (benefit.reward_id && !uniqueBenefitsMap.has(benefit.reward_id)) {
      uniqueBenefitsMap.set(benefit.reward_id, benefit);
    }
  });
  
  const uniqueBenefits = Array.from(uniqueBenefitsMap.values());
  const requestedLimit = typeof params.limit === 'number' ? params.limit : uniqueBenefits.length;
  
  return uniqueBenefits.slice(0, requestedLimit);
};

export const getBenefitAllocations = async (params = {}) => {
  return await fetchPersea(`/benefits/allocations`, 'GET', params);
};



export const claimBenefit = async (body = {}) => {
  return await fetchPersea(`/plug_and_play/campaign/mission/claim`, 'POST', {}, body);
};

export const validateIfUserClaimedBenefit = async (params = {}) => {
  return await fetchPersea(`/campaign/mission/benefit/claim`, 'GET', params);
};

interface MTXBurnMessageBody {
  token_id?: number;
  user_address?: string;
  collection_key?: string;
  benefit_type_id: number;
  benefit_address: string;
  amount: number;
  type: string;
}

interface MTXBurnMessageParams {
  body: MTXBurnMessageBody;
}

export const benefitsUserMTXBurnMessage = async ({
  body
}: MTXBurnMessageParams) => {
  try {
    return await fetchPersea(
      `/benefits/user/mtx/burn-message`,
      'POST',
      {},
      body
    );
  } catch (error) {
    console.error('Error in benefitsUserMTXBurnMessage:', error);
    throw error;
  }
};

export const benefitsNFTMTXBurnMessage = async ({
  body
}: MTXBurnMessageParams) => {
  try {
    return await fetchPersea(
      `/benefits/nft/mtx/burn-message`,
      'POST',
      {},
      body
    );
  } catch (error) {
    console.error('Error in benefitsNFTMTXBurnMessage:', error);
    throw error;
  }
};

const URL_MTX = `/benefits//nft/mtx/burn`;
export const benefitsNFTMTXBurn = async ({
  domain = import.meta.env.VITE_DOMAIN,
  body = {
    "contract_address": "string",
    "signature": "string",
    "forward_request": {
      "_from": "string",
      "value": 0,
      "gas": 0,
      "nonce": 0,
      "data": "string"
    }
  }
}:{
  domain?: string;
  body?: object;
}) => {
  return await fetchPersea(`${URL_MTX}?domain=${domain}`, 'POST', {}, body);
};